"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
//# sourceMappingURL=AssignationOfferRPC.types.js.map